/**
 * MacroBaby — Features de página de produto:
 *  - Produtos relacionados (.productRelacionados)
 *  - "Compre Junto" / Frequently bought together (.productCompreJunto)
 *  - Atualização do mini-cart após Add to Cart custom
 *
 * Depende de: jQuery, mb-carousel.js
 */
(function ($) {
    function openMiniCartDrawer() {
        const miniCartElement = document.getElementById("mini-cart");
        const cartToggleElement = document.querySelector('.header__action-item--cart .header__cart-toggle[data-action="toggle-mini-cart"]');

        if (!miniCartElement || !cartToggleElement) return;

        cartToggleElement.setAttribute("aria-expanded", "true");

        if (window.matchMedia("screen and (max-width: 640px)").matches) {
            const cartIcon = cartToggleElement.querySelector(".header__cart-icon");
            if (cartIcon) cartIcon.setAttribute("aria-expanded", "true");
        }

        miniCartElement.setAttribute("aria-hidden", "false");
        document.body.classList.add("no-mobile-scroll");
    }

    function refreshMiniCartUI() {
        $("#mini-cart").load(window.location.href + "  #mini-cart > *");
        $(".header__cart-count").load(window.location.href + "  .header__cart-count");

        setTimeout(() => {
            openMiniCartDrawer();
        }, 600);
    }

    function formatMoney(v) {
        v += "";
        v = v.replace(/([0-9]{2})$/g, ".$1");
        return v.length > 6 ? v.replace(/([0-9]{3}),([0-9]{2}$)/g, ",$1.$2") : v;
    }

    const isProductTemplate = () =>
        $(".template-product").length && !window.location.href.includes("macrobaby-4d-ultrasound-packages");

    function loadRelatedProducts() {
        if (!isProductTemplate()) return;
        window.relacted = 0;
        const ids = $("#relacionados").val().split(",");
        [...new Set(ids)].forEach(function (id) {
            $.ajax({
                url: `/products/${id}.js`,
                type: "GET",
                dataType: "json",
                success: function (p) {
                    if (p.available !== true) return;
                    const html = `
                        <div class="item" data-js="${window.relacted + 1}">
                            <a href="${p.url}" class="product-item__image-wrapper">
                                <div class="aspect-ratio aspect-ratio--square">
                                    <img class="product-item__primary-image image--fade-in lazyloaded" data-media-id="${p.id}" width="214" height="214" data-src="${p.images}" data-sizes="auto" data-widths="[200,300,400,500,600,700,800]" alt="${p.title}" sizes="214px" src="${p.images}">
                                    <noscript><img class='lazyload' src="${p.images}" alt="${p.title}"></noscript>
                                </div>
                            </a>
                            <div class="product-item__info">
                                <div class="product-item__info-inner">
                                    <a class="product-item__vendor link" href="${p.url}">${p.vendor}</a>
                                    <a href="${p.url}" class="product-item__title text--strong link">${p.title}</a>
                                    <div class="product-item__price-list price-list">
                                        <span class="price" style="display: none">
                                            <span class="visually-hidden">Sale price</span>From <span>$${formatMoney(p.price)}</span>
                                        </span>
                                    </div>
                                    <div class="addToCartCustom product-item__action-button button button--small button--primary" data-estoque="${p.available}" data-id="${p.variants[0].id}" data-action="add-to-cart">Add to cart</div>
                                </div>
                            </div>
                        </div>
                    `;
                    $(".productRelacionados .carrossel").append(html);
                    mbCarousel(".productRelacionados .carrossel", {
                        items: 4,
                        fullWidth: true,
                        buttons: true,
                        dots: false,
                        responsive: {
                            1360: { inherit: true, items: 4 },
                            800:  { dots: false, buttons: true, items: 2, fullWidth: true }
                        }
                    });
                    if ($(".carrossel").is(":empty")) $(".productRelacionados").hide();
                },
                error: function (e) { console.log("error", e); }
            });
        });
    }

    function bindAddToCartCustom() {
        $(document).on("click", ".addToCartCustom", function () {
            const id = $(this).closest(".owl-item").find(".addToCartCustom").attr("data-id");
            $.ajax({
                url: "/cart/add.js",
                type: "POST",
                dataType: "json",
                data: { items: [{ id, quantity: 1 }] },
                success: function () {
                    refreshMiniCartUI();
                },
                error: function (e) { console.log("Erro de requisição!", e); }
            });
        });
    }

    function loadCompreJunto() {
        if (!isProductTemplate()) return;

        var raw = $("#compreJunto").val();
        if (!raw) return;

        var handles = raw.split(",").map(function(h) { return h.trim(); }).filter(Boolean);
        handles = handles.filter(function(h, i) { return handles.indexOf(h) === i; });
        if (!handles.length) return;

        var loaded = new Array(handles.length);
        var completed = 0;

        handles.forEach(function(handle, idx) {
            $.ajax({
                url: "/products/" + handle + ".js",
                type: "GET",
                dataType: "json",
                success: function(p) {
                    if (p.available) {
                        var variant = null;
                        for (var i = 0; i < p.variants.length; i++) {
                            if (p.variants[i].available) { variant = p.variants[i]; break; }
                        }
                        if (!variant) variant = p.variants[0];
                        loaded[idx] = { product: p, variant: variant };
                    }
                    completed++;
                    if (completed === handles.length) renderCompreJunto(loaded.filter(Boolean));
                },
                error: function() {
                    completed++;
                    if (completed === handles.length) renderCompreJunto(loaded.filter(Boolean));
                }
            });
        });
    }

    function renderCompreJunto(items) {
        if (!items.length) return;

        var $cards = $(".cj-cards");
        var $rows  = $(".cj-product-list");
        var total = 0;
        var variantIds = [];

        items.forEach(function(item, idx) {
            var p = item.product;
            var v = item.variant;
            var img = p.featured_image || (p.images && p.images[0]) || "";

            if (idx > 0) {
                $cards.append(
                    '<span class="cj-plus">' +
                    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
                    '<path d="M8 2V14M2 8H14" stroke="#C24768" stroke-width="2" stroke-linecap="round"/>' +
                    "</svg></span>"
                );
            }

            $cards.append(
                '<a class="cj-card" href="' + p.url + '">' +
                '<img src="' + img + '" alt="' + p.title.replace(/"/g, "&quot;") + '" loading="lazy" width="184" height="184">' +
                "</a>"
            );

            $rows.append(
                '<div class="cj-row">' +
                '<span class="cj-row-name">' + p.title + "</span>" +
                '<span class="cj-row-price">$' + formatMoney(v.price) + "</span>" +
                "</div>"
            );

            total += v.price;
            variantIds.push(v.id);
        });

        $(".cj-summary-value").text("$" + formatMoney(total));
        $(".cj-add-btn").data("variants", variantIds);
        $(".cj-section").removeClass("is-hidden");
    }

    function bindBtnCompreJunto() {
        $(document).on("click", ".cj-add-btn", function() {
            var $btn = $(this);
            var variants = $btn.data("variants");
            if (!variants || !variants.length) return;

            $btn.find(".loading").addClass("is-loading");

            var items = variants.map(function(id) { return { id: id, quantity: 1 }; });
            $.ajax({
                url: "/cart/add.js",
                type: "POST",
                contentType: "application/json",
                data: JSON.stringify({ items: items }),
                success: function() {
                    refreshMiniCartUI();
                    setTimeout(function() { $btn.find(".loading").removeClass("is-loading"); }, 700);
                },
                error: function(e) {
                    console.log("Erro ao adicionar ao carrinho", e);
                    $btn.find(".loading").removeClass("is-loading");
                }
            });
        });
    }

    $(document).ready(function () {
        loadRelatedProducts();
        bindAddToCartCustom();
        loadCompreJunto();
        bindBtnCompreJunto();
    });
})(jQuery);
